import { Grid, Typography } from "@mui/material";
import * as React from "react";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ColDef, GetRowIdParams, GridOptions, IServerSideGetRowsParams } from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { usePaymentRequestRepository } from "../../../api/repositories/PaymentRequestRepository";
import { useAgGridLocale } from "../../../../../config/globalConfig";
import AgGridCustomTable from "../../../../../util/component/AgGridCustomTable";
import EmptyState from "../../../../../util/component/EmptyState";
import { useParams } from "react-router-dom";
import DoneAllRoundedIcon from "@mui/icons-material/DoneAllRounded";
import { formatDate } from "../../../utils/FormatUtils";

const UnpaidHistory = () => {
    const { t } = useTranslation("finance", { keyPrefix: "payments.payment-request" });
    const { getUnpaidPaymentHistory } = usePaymentRequestRepository()
    const { id } = useParams();
    const agGridLocale = useAgGridLocale();
    const gridRef = useRef<AgGridReact>(null);
    const [unpaidHistoryTable, updateUnpaidHistoryTable] = useState(false);

    useEffect(() => {
        if (unpaidHistoryTable) {
            gridRef?.current?.api?.setServerSideDatasource(createDatasource());
            updateUnpaidHistoryTable(false);
        }
    }, [unpaidHistoryTable]);

    const columns: ColDef[] = [
       /* {
            field: "id",
            headerName:  t('pages.wizard.form.labelUUID'),
            unSortIcon: true,
            tooltipField: "id",
        },*/
        {
            field: "createdDate",
            headerName: t('pages.wizard.form.labelCreationDate'),
            cellRenderer: (params: any) => params?.value ? formatDate(params.value) : "",
            unSortIcon: true,
        },
        {
            field: "lock",
            headerName:  t('pages.wizard.form.labelLockedUser'),
            unSortIcon: true,
            cellRenderer: (params: any) => params?.value ? <DoneAllRoundedIcon color={"success"}/> : "",
            tooltipField: "lockedUser",
        },
        {
            field: "watchList",
            headerName:  t('pages.wizard.form.labelUserOnWL'),
            unSortIcon: true,
            cellRenderer: (params: any) => params?.value ? <DoneAllRoundedIcon color={"success"}/> : "",
            tooltipField: "watchList",
        },
        {
            field: "smsSent",
            headerName:  t('pages.wizard.form.labelSentSms'),
            unSortIcon: true,
            cellRenderer: (params: any) => params?.value && params?.value != "NONE" ? <DoneAllRoundedIcon color={"success"}/> : "",
            tooltipField: "smsSent",
        },
        {
            field: "emailSent",
            headerName:  t('pages.wizard.form.labelSentEmail'),
            unSortIcon: true,
            cellRenderer: (params: any) => params?.value && params?.value != "NONE" ? <DoneAllRoundedIcon color={"success"}/> : "",
            tooltipField: "emailSent",
        }

    ];

    const toolbar = { renderInfo: () => <></> }

    const gridOptions: GridOptions = {
        getRowId: (params: GetRowIdParams) => params.data['id'],
        suppressRowClickSelection: true,
        domLayout: 'autoHeight',
        rowModelType: 'serverSide',
        cacheBlockSize: 10,
        defaultColDef: {
            sortable: true,
            resizable: false,
            wrapHeaderText: true,
            autoHeight: true,
        },
        columnDefs: columns,
        serverSideInfiniteScroll: true,
        localeText: agGridLocale,
        onGridReady: (params) => {
            params.api.setServerSideDatasource(createDatasource());
        },
        serverSideDatasource: createDatasource(),
    };

    function createDatasource() {
        return {
            getRows: async (params: IServerSideGetRowsParams) => {
                try {
                     if (id !== undefined) {
                       getUnpaidPaymentHistory(id).then((response) => {
                           let result = response.result;
                           if (result.length === 0) {
                               gridRef.current!.api.showNoRowsOverlay()
                           } else {
                               gridRef.current!.api.hideOverlay();

                           }
                           params.success({
                               rowData: result,
                               rowCount: result.length,
                           });

                       }).catch(() => params.fail());
                    }
                } catch (e) {
                    params.fail();
                }
            }
        };
    }

    const noRowsOverlayComponent = useMemo<any>(() => {
        return EmptyState;
    }, []);

    const noRowsOverlayComponentParams = useMemo<any>(() => {
        return {
            title: t("pages.wizard.form.no-rows.title"),
            content: t("pages.wizard.form.no-rows.content")
        };
    }, []);


    return (
        <Grid container item spacing={2} alignItems={'center'}>

            <Grid item xs={12}>
                <Typography variant={'body2'} color={'primary.light'} fontWeight={700} >
                    {t('pages.wizard.form.titleUnpaid').toUpperCase()}
                </Typography>
            </Grid>

            <Grid container>
                <Grid item xs={12} sx={{padding: "16px"}}>
                    <AgGridCustomTable gridOptions={gridOptions} gridRef={gridRef} toolbar={toolbar}
                                       noRowsOverlayComponent={noRowsOverlayComponent}
                                       noRowsOverlayComponentParams={noRowsOverlayComponentParams}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default UnpaidHistory;